import ConfirmDialog from '@/commons/confirm-dialog/ConfirmDialog';
import { Iconic } from '@/commons/iconic';
import { ActionsProps } from '@/components/Table/types/actions';
import { PATH_DASHBOARD } from '@/routes/paths';
import {  MenuItem } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { deleteUser } from '@/services';
import { useSnackbar } from 'notistack';
import { Roles, translates } from '@/utils';
import { useRole } from '@/hooks/useRole';
import DialogMenu from '@/commons/dialog-menu';
import { DialogChangeRol } from '@/components/pop-modal/dialog-change-rol';
import { Button } from '@PorkyCol/button';


export const ListActionsUsers = ({
  value,
  openConfirm,
  setOpenConfirm,
  setOpenPopover,
  data
}: ActionsProps) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const { authorized } = useRole([Roles.ADMIN]);

  const navigate = useNavigate();
  const { mutateAsync: mutateDelete } = useMutation({
    mutationFn: deleteUser,
    mutationKey: ['users', value],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      enqueueSnackbar('User Disable !', { variant: 'success' });
    },
    onError: () => {
      enqueueSnackbar('Error Delete User !', { variant: 'error' });
    },
  });
  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const editHandle = () => {
    navigate(PATH_DASHBOARD.users.edit(data?.uid ?? value));
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const onDeleteRow = async () => {
    await mutateDelete(value);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      <MenuItem
        onClick={() => {
          editHandle();
        }}
      >
        <Iconic icon="eva:edit-fill" />
        {translates.edit}
      </MenuItem>

      {authorized && (
        <DialogMenu
          icon="material-symbols:change-circle-outline"
          text={`${translates.change} rol`}
          title={`${translates.change} rol`}
          component={(props: any) => <DialogChangeRol value={value} {...props} />}
        />
      )}

      <MenuItem
        onClick={() => {
          handleOpenConfirm();
        }}
        sx={{ color: 'error.main' }}
      >
        <Iconic icon="eva:trash-2-outline" />
        {translates.delete}
      </MenuItem>

      <ConfirmDialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        title={translates.delete}
        content={translates.messageDelete}
        action={
          <Button
            variant="solid"
            color="danger"
            onClick={() => {
              onDeleteRow();
              handleClosePopover();
            }}
          >
            {translates.delete}
          </Button>
        }
      />
    </>
  );
};
